import { Link } from 'react-router-dom';
import { Home, Search } from 'lucide-react';
import SEOHead from '../components/SEOHead';

export default function NotFoundPage() {
  return (
    <div data-testid="not-found-page" className="min-h-screen flex items-center justify-center bg-[#0A0A0A] py-24 px-4">
      <SEOHead title="Page Not Found" noindex />
      <div className="text-center max-w-md">
        <p className="text-[10rem] sm:text-[12rem] leading-none text-[#D4AF37]/20 font-light hero-headline" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
          404
        </p>
        <h1 className="text-3xl sm:text-4xl tracking-tight font-light text-white -mt-8 mb-3" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
          Lost in the bottle
        </h1>
        <p className="text-white/50 font-sans text-sm leading-relaxed mb-8">
          The page you're looking for has evaporated into thin air. Let's get you back to a scent that lingers.
        </p>
        <div className="flex flex-wrap gap-3 justify-center">
          <Link
            to="/"
            data-testid="not-found-home-btn"
            className="btn-shimmer flex items-center gap-2 px-6 py-3 bg-[#D4AF37] text-black text-xs uppercase tracking-[0.2em] font-sans font-medium hover:bg-[#E5C75A] transition-colors"
          >
            <Home className="w-4 h-4" /> Home
          </Link>
          <Link
            to="/shop"
            data-testid="not-found-shop-btn"
            className="flex items-center gap-2 px-6 py-3 border border-[#D4AF37]/40 text-[#D4AF37] text-xs uppercase tracking-[0.2em] font-sans hover:bg-[#D4AF37]/10 transition-colors"
          >
            <Search className="w-4 h-4" /> Browse fragrances
          </Link>
        </div>
      </div>
    </div>
  );
}
